// Разрешённые типы файлов для загрузчиков Uppy — одним списком на всё приложение.
//
// Почему не `image/*`, как было раньше в восьми компонентах: этот шаблон включает
// `image/svg+xml`, то есть SVG проходил фильтр совершенно штатно. А SVG — это не
// картинка, а исполняемый документ: разметка со скриптами и обработчиками событий.
//
// Инцидент 2026-08-24. Сотрудник грузил аватарки машин, один файл оказался SVG.
// Rack::Attack сканирует первые 64 КБ тела на XSS-паттерны, нашёл `<svg` и забанил
// IP на сутки (правило "fail2ban xss payload", maxretry 1). Клиент сидит за NAT —
// отрезало весь офис: 403 на любой запрос, включая вход и WebSocket.
//
// Список белый, а не чёрный: перечисляем то, что принимаем, а не то, что запрещаем.
// Чёрный список пришлось бы дополнять на каждый новый формат-документ, который
// браузер отдаёт под типом image/* (svg, а завтра ещё что-нибудь).
//
// MIME-типы и расширения перечислены парами намеренно: Uppy сверяет `file.type`,
// который для HEIC/HEIF часть браузеров не проставляет вовсе — тогда срабатывает
// проверка по расширению.
export const RASTER_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "image/bmp",
  "image/tiff",
  "image/heic",
  "image/heif",
  "image/avif",
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".gif",
  ".bmp",
  ".tif",
  ".tiff",
  ".heic",
  ".heif",
  ".avif",
];

// Документы — там, где загрузчик принимает не только фото (договоры, файлы машин).
export const DOCUMENT_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/pdf",
];

// Видео — только чек-ин (фото и видео осмотра при выдаче/приёме).
export const VIDEO_TYPES = ["video/*", ".mov"];

export const RASTER_IMAGE_AND_DOCUMENT_TYPES = [
  ...RASTER_IMAGE_TYPES,
  ...DOCUMENT_TYPES,
];
